import Component from 'video.js/dist/types/component';
import Player from 'video.js/dist/types/player';

export const createSkipButtons = (player: Player, controlBar: Component, playButton: Element) => {
  if (!playButton.parentNode) return;

  const skipTimeGroup = document.createElement('div');
  skipTimeGroup.className = 'vjs-skip-time-group';

  const skipBackBtn = document.createElement('button');
  skipBackBtn.className = 'vjs-skip-backward-10 vjs-control vjs-button';
  skipBackBtn.innerHTML = '<i class="fa-regular fa-arrow-rotate-left-10"></i>';
  skipBackBtn.title = 'Skip backward 10 seconds';
  skipBackBtn.onclick = () => {
    const currentTime = player.currentTime();
    if (currentTime !== undefined) {
      player.currentTime(Math.max(0, currentTime - 10));
    }
  };

  const skipFwdBtn = document.createElement('button');
  skipFwdBtn.className = 'vjs-skip-forward-10 vjs-control vjs-button';
  skipFwdBtn.innerHTML = '<i class="fa-regular fa-arrow-rotate-right-10"></i>';
  skipFwdBtn.title = 'Skip forward 10 seconds';
  skipFwdBtn.onclick = () => {
    const currentTime = player.currentTime();
    const duration = player.duration();
    if (currentTime !== undefined && duration !== undefined) {
      player.currentTime(Math.min(duration, currentTime + 10));
    }
  };

  const skipButtonsContainer = document.createElement('div');
  skipButtonsContainer.className = 'vjs-skip-buttons-container';
  skipButtonsContainer.appendChild(skipBackBtn);
  skipButtonsContainer.appendChild(skipFwdBtn);

  skipTimeGroup.appendChild(skipButtonsContainer);

  const timeDisplayContainer = document.createElement('div');
  timeDisplayContainer.className = 'vjs-time-display-container';

  const currentTime = controlBar.el().querySelector('.vjs-current-time');
  const timeDivider = controlBar.el().querySelector('.vjs-time-divider');
  const duration = controlBar.el().querySelector('.vjs-duration');

  if (currentTime) timeDisplayContainer.appendChild(currentTime);
  if (timeDivider) timeDisplayContainer.appendChild(timeDivider);
  if (duration) timeDisplayContainer.appendChild(duration);

  skipTimeGroup.appendChild(timeDisplayContainer);

  playButton.parentNode.insertBefore(skipTimeGroup, playButton.nextSibling);
};
